if (!customElements.get('windlust-colour-links')) {
  class WindlustColourLinks extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.links = Array.from(this.querySelectorAll('[data-product-url]'));
      this.variants = new Map(this.links.map(link => [link, JSON.parse(link.querySelector('[data-colour-variants]').textContent)]));
      this.sizeValues = new Map(JSON.parse(this.querySelector('[data-size-values]').textContent).map(value => [String(value.id), value.name]));
      this.status = this.querySelector('[data-colour-status]');
      this.updateLinks(this.currentSize());
      document.addEventListener('change', event => {
        if (event.target.form?.getAttribute('id') === this.dataset.formId && event.target.dataset.optionPosition === this.dataset.sizePosition) {
          this.updateLinks(this.sizeValues.get(String(event.target.value)) || this.dataset.size);
        }
      }, options);
      document.addEventListener('variant:change', event => {
        if (event.target.getAttribute?.('id') === this.dataset.formId) this.updateLinks(this.currentSize());
      }, options);
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-product-url]');
        if (!link) return;
        this.updateLinks(this.currentSize());
        if (link.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          this.showStatus(link);
        }
      }, options);
      this.addEventListener('focusin', event => this.showStatus(event.target.closest('[data-product-url]')), options);
      this.addEventListener('pointerover', event => this.showStatus(event.target.closest('[data-product-url]')), options);
      this.addEventListener('focusout', () => this.showStatus(null), options);
      this.addEventListener('pointerleave', () => this.showStatus(null), options);
    }

    disconnectedCallback() { this.controller?.abort(); }

    currentSize() {
      const input = Array.from(document.querySelectorAll('input[data-option-position]:checked')).find(input => input.form?.getAttribute('id') === this.dataset.formId && input.dataset.optionPosition === this.dataset.sizePosition);
      return this.sizeValues.get(String(input?.value)) || this.dataset.size;
    }

    updateLinks(size) {
      this.dataset.size = size;
      for (const link of this.links) {
        const variant = this.variants.get(link).find(variant => variant.size === size);
        const url = new URL(link.dataset.productUrl, window.location.origin);
        const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const unavailable = !variant?.available;
        link.toggleAttribute('data-unavailable', unavailable);
        if (variant) {
          url.searchParams.set('variant', variant.id);
          link.href = url.pathname + url.search;
          link.removeAttribute('aria-disabled');
          link.removeAttribute('tabindex');
        } else {
          link.removeAttribute('href');
          link.setAttribute('aria-disabled', 'true');
          link.tabIndex = 0;
        }
        const template = variant ? this.dataset.soldOut : this.dataset.notOffered;
        link.dataset.notice = unavailable ? template.replace('[size]', size).replace('[colour]', link.dataset.colour) : '';
        link.setAttribute('aria-label', link.dataset.notice || link.dataset.colour);
        link.title = link.dataset.notice || link.dataset.colour;
      }
      this.showStatus(null);
    }

    showStatus(link) {
      this.status.textContent = link?.dataset.notice || '';
      this.status.hidden = !this.status.textContent;
    }
  }
  customElements.define('windlust-colour-links', WindlustColourLinks);
}
